import { CheckoutError as BaseCheckoutError } from './CheckoutError';
import { inject } from './inject';

export const CheckoutError = inject(BaseCheckoutError);
